export const CTL_SECTION_TITLE = "전국 Color to life";

export const CTL_SECTION_DESCRIPTION =
  "전국 입점 매장을 지도와 목록으로 확인할 수 있습니다.";

export const CTL_TABLE_COLUMNS = [
  { key: "name", label: "지점명" },
  { key: "region", label: "지역" },
  { key: "address", label: "주소" },
  { key: "linkUrl", label: "링크" },
] as const;

export const CTL_TABLE_SKELETON_COUNT = 8;

export const KAKAO_MAP_DEFAULT_CENTER = {
  lat: 36.5,
  lng: 127.8,
};

export const KAKAO_MAP_DEFAULT_LEVEL = 12;
